import * as React from "react";
import { IconProps } from "../types";

const MicrophoneSlashOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M12.25 5.25V5C12.25 3.205 10.795 1.75 9 1.75C7.205 1.75 5.75 3.205 5.75 5V8C5.75 8.575 5.899 9.115 6.161 9.583"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.25 8.25V8C12.25 9.795 10.795 11.25 9 11.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.25 8C15.25 11.452 12.452 14.25 9 14.25C7.6 14.25 6.307 13.79 5.265 13.013M2.75 8C2.75 9.139 3.055 10.207 3.587 11.127"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 14.25V16.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 16L16 2"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default MicrophoneSlashOutlineIcon;
